/*
 * Core logic for running and managing remote chats.
 */

import { callNutAPI } from './NutAPI';
import type { ChatResponse } from './Response';
import type { SimulationData } from '@/messages/simulationData';
import type { PageContents } from '@/messages/pageContents';
import type { Message } from './Message';
import { USER_MESSAGE_RESPONSE_DATA_CATEGORY, UserMessageResponseData } from './UserMessageResponseData';

export type ChatResponseCallback = (response: ChatResponse) => void;

export enum ChatMode {
  UserMessage = 'UserMessage',
  InlineAppUserMessage = 'InlineAppUserMessage',
  DevelopApp = 'DevelopApp',
}

// Information about a component referenced on a page during a visit.
export interface ChatReferenceComponent {
  // React component hierarchy down to the referenced element. The first component is
  // the root, and subsequent entries will contain page names, containers etc going
  // down to the referenced component.
  componentNames: string[];
}

// Information describing a user's visit to the app.
export interface VisitData {
  repositoryId: string;
  componentReference?: ChatReferenceComponent;
  simulationData?: SimulationData;
  pageContents?: PageContents;
}

export interface NutChatRequest {
  appId: string;
  mode?: ChatMode;
  messages?: Message[];
  visitDataId?: string;
  retryBugReportName?: string;
}

// Add data here to mock responses while testing.
const gMockResponses: ChatResponse[] | undefined = undefined;

export async function sendChatMessage(request: NutChatRequest, onResponse: ChatResponseCallback) {
  console.log('sendChatMessage', JSON.stringify(request));

  if (gMockResponses) {
    for (const response of gMockResponses) {
      onResponse(response);
    }
    return;
  }

  await callNutAPI('chat', request, onResponse);

  console.log('sendChatMessage finished');
}
